import { render, staticRenderFns } from "./HomeView.vue?vue&type=template&id=b04ecefe"
import script from "./HomeView.ts?vue&type=script&lang=ts&external"
export * from "./HomeView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports